import { NavMenu } from '@sailadv/hdata-ui';
import { memo, useState } from 'react';

import { NavigationMenu } from '@/entities/navigation';
import {
	getSidebarCollapsed,
	setSidebarCollapsed,
} from '@/widgets/sidebar/model/helpers/sidebar-collapsed-storage.helper';

const SidebarComponent = () => {
	const [collapsed, setCollapsed] = useState(getSidebarCollapsed);

	const handleCollapsedChange = (value: boolean) => {
		setSidebarCollapsed(value);
		setCollapsed(value);
	};

	// Sidebar uses the page background instead of its own hdata-ui token
	return (
		<NavMenu
			collapsed={collapsed}
			onCollapsedChange={handleCollapsedChange}
			aria-label="Main navigation"
			className="border-r border-sidebar-border [--hdata-sidebar:var(--hdata-background)]"
		>
			<NavigationMenu />
		</NavMenu>
	);
};

export default memo(SidebarComponent);
